import { apiErrorToToast } from "@/lib/utils";
import { newUser } from "@/requests/users/new-user.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "sonner";

export const useNewUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: newUser,
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["companies", variables.companyId, "users"],
      });
      toast.success(
        `Se ha enviado una contraseña temporal a ${variables.email}`,
      );
    },
  });
};
